import { render, staticRenderFns } from "./Iryohokens.vue?vue&type=template&id=abf31c6a&"
import script from "./Iryohokens.vue?vue&type=script&lang=ts&"
export * from "./Iryohokens.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports